import * as React from 'react';
import {PageComponent} from "../pageComponent";
import {Server} from "../../services/server";
import {lazyInject} from "../../services/container";
import {History} from 'history';
import {tracked} from "../../decorators/tracked";
import DocumentTitle from 'react-document-title';
import {ClubcardSignupModal} from '../clubcardSignupModal/clubcardSignupModal';

interface ClubcardProps
{
    history: History;
}
export class ClubcardPage extends PageComponent<ClubcardProps>
{
    @lazyInject(Server)
    private server: Server;

    @tracked
    private showModal: boolean = false;

    public render(): React.ReactNode
    {
        return <div className="nav-page clubcard-page">
            <DocumentTitle title={this.translate.translate('clubcardRequestPageTitle') as any as string} />
            <img className="logo" src={this.translate.translate('clubcardOpenImageUrl') as any as string} alt="" />
            <div className="clubcard-reserve-button" onClick={()=> this.showModal = true}>
                {this.translate.translate('clubcardReserveButtonLabel')}
            </div>
            <ClubcardSignupModal
                history={this.props.history}
                showModal={this.showModal}
                onDismiss={()=>{this.showModal = false;}}
            />
        </div>;
    }


}